module.exports = __webpack_public_path__ + "static/media/business-services.e1173a6e.jpg";